let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6FrKI")).then(() => parcelRequire('7D8Kw'));